module.exports = __webpack_public_path__ + "media/very_well.027833bd.mp3";